import { useState } from 'react';

interface ImageGalleryProps {
  images: string[];
  productName: string;
}

export default function ImageGallery({ images, productName }: ImageGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [zoomed, setZoomed] = useState(false);

  const displayImages = images.length > 0 ? images : [
    'https://readdy.ai/api/search-image?query=Generic%20product%20placeholder%20clean%20white%20background%20minimal%20professional&width=600&height=600&seq=prod-fallback-01&orientation=squarish',
  ];

  return (
    <div className="flex flex-col gap-3">
      {/* Main Image */}
      <div
        className="relative aspect-square rounded-xl md:rounded-2xl bg-background-100 overflow-hidden border border-background-200/60 cursor-zoom-in"
        onClick={() => setZoomed(true)}
      >
        <img
          src={displayImages[activeIndex]}
          alt={productName}
          className="w-full h-full object-cover object-top"
        />
        {displayImages.length > 1 && (
          <div className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-950/70 text-background-50 text-xs font-medium">
            {activeIndex + 1} / {displayImages.length}
          </div>
        )}
      </div>

      {/* Thumbnails */}
      {displayImages.length > 1 && (
        <div className="flex gap-2 overflow-x-auto pb-1">
          {displayImages.map((img, idx) => (
            <button
              key={idx}
              type="button"
              onClick={() => setActiveIndex(idx)}
              className={`flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden border-2 transition-all ${
                idx === activeIndex ? 'border-primary-500' : 'border-background-200/60 hover:border-background-300'
              }`}
            >
              <img
                src={img}
                alt={`${productName} view ${idx + 1}`}
                className="w-full h-full object-cover object-top"
              />
            </button>
          ))}
        </div>
      )}

      {/* Zoom Modal */}
      {zoomed && (
        <div
          className="fixed inset-0 z-50 bg-foreground-950/90 flex items-center justify-center p-4"
          onClick={() => setZoomed(false)}
        >
          <button
            type="button"
            onClick={() => setZoomed(false)}
            className="absolute top-4 right-4 w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center hover:bg-background-50 transition-colors"
          >
            <i className="ri-close-line text-xl text-foreground-800" />
          </button>
          <img
            src={displayImages[activeIndex]}
            alt={productName}
            className="max-w-full max-h-[85vh] object-contain rounded-xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}